import axios from "@core/plugins/axios.plugin"
import { handleServiceCall } from "@services/helpers"
import type { ConsentementLegacy } from "@types"

// =====================
// Services
// =====================
export class ConsentService {
    /**
     * GET /v5/consentement/:_id_consentement/preview
     * Récupère la previsualisation d'un consentement
     * @param _id_consentement - identifiant unique de la source
     * @param abortController?: AbortController
     *
     * @return Un objet contenant les informations de prévisualisation du consentement
     */
    async getPreviewConsent(
        _id_consentement: string,
        abortController?: AbortController
    ) {
        return handleServiceCall<any>(async () => {
            const { data: sourceUpdated } = await axios.get(
                `/api/metier/v5/consentement/${_id_consentement}/preview`,
                {
                    signal: abortController?.signal,
                }
            )
            return sourceUpdated
        })
    }

    /**
     * DELETE /v5/consentement/:_id_consentement
     * Permet de révoquer un consentement
     * @param _id_consentement - id du consentement à révoquer
     * @param abortController?: AbortController
     */
    async revokeConsent(
        _id_consentement: string,
        abortController?: AbortController
    ) {
        return handleServiceCall<void>(async () => {
            await axios.delete(
                `/api/metier/v5/consentement/${_id_consentement}`,
                {
                    signal: abortController?.signal,
                }
            )
        })
    }
    /**
     * GET /v5/consentement
     * Récupère les consentements d'un utilisateur
     * @return {Promise<ConsentementLegacy[]>} - liste des consentements
     */
    async getConsents(): Promise<ConsentementLegacy[]> {
        const { data } = await axios.get("/api/metier/v5/consentement", {
            params: {
                noPage: true,
            },
        })
        return data
    }
}
